export const firebaseConfig = {
  apiKey: 'AIzaSyBruld1-41Rz7gGoPfaBNNo0DXq0S_G-q0',
  authDomain: 'doocrate2.firebaseapp.com',
  databaseURL: 'https://doocrate2.firebaseio.com',
  storageBucket: '',
  projectId: 'doocrate2',
  defaultDomain: 'staging.doocrate.com',
  // This loads the Event planning page - Set to 2,3 to change it
  // Or leave it empty to show all the tasks as the default page
  // Setting this destroys ability for users to keep filters and send each other filtered pages
  //defaultPageToLoad: '?complete=false' //'?filter=taskType&text=3'
};
